export const DEFAULT_EMAIL_NOTE = "Please note that pricing for the following products has been updated:"
